module.exports = __webpack_public_path__ + "media/images/emblems/Schmitten-FR--coat_of_arms-14e69937ad9849c67ccd269c97427f35.svg";